(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('weekschemeRow', ['$uibModal', 'ItemTableService', 'HelperService', 'Weekscheme', 'WeekschemeService', 'DayschemeService', 'Alert', '$rootScope', WeekschemeRowDirectiveFn]);

    function WeekschemeRowDirectiveFn($uibModal, ItemTableService, HelperService, Weekscheme, WeekschemeService, DayschemeService, Alert, $rootScope) {

        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekscheme-row.template.html'

        };
        return directive;

        function link(scope) {
            // if editing -> this is the original backup
            var original = null;

            // copy in action ?
            var copy = false;
            
            scope.allowedToBringBack = $rootScope.isRingfoonAdminOnly;

            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                var modalInstance = HelperService.deactivatingConfirmationModal();
                modalInstance.result.then(function() {
                    WeekschemeService.deactivate(scope.item.id).then(function (result) {
                        Alert.success(result);
                        // ItemTableService.deactivate(scope.item, scope.item.vmIndex);
                        ItemTableService.remove(scope.item.vmIndex);
                    });
                });
            };

            scope.bringBack = () => {
                WeekschemeService.activate(scope.item.id).then((result) => {
                    scope.item.deleted = false;
                });
            };

            // edit item
            scope.editNameAndStarteDate = function () {
                original = ItemTableService.edit(scope.item);
            };

            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    ItemTableService.remove(scope.item.vmIndex);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, scope.item.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // move item up
            scope.moveUp = function () {
                move(true);
            };

            // move item down
            scope.moveDown = function () {
                move(false);
            };

            // reorder the item in the list
            function move(up) {
                // reorder in the filtered list -> deleted items will be ignored !!!

                // first of all -> get related item
                var related = up ? scope.results[scope.$index - 1] : scope.results[scope.$index + 1];
                if (related === null || typeof related === 'undefined') {
                    return;
                } //if

                // do the reordering
                reorder(scope.item, related);

            }

            // reorder items
            function reorder(item, related) {
                return WeekschemeService.reorder(item.id, related.id).then(function (result) {
                    // list of updated items in results

                    // remove and put
                    ItemTableService.remove(item.vmIndex);
                    ItemTableService.remove(related.vmIndex);
                    ItemTableService.put(result[0]);
                    ItemTableService.put(result[1]);

                    Alert.success('Items reordered successfully');
                }).$promise;
            } // reorder


            // save editing values
            scope.save = function () {

                // prepare for save
                var item = new Weekscheme();
                item.extend(scope.item);
                item.prepareForSave();

                //save or udpate
                if (item.id > 0) {
                    WeekschemeService.update(item.id, item).then(function (result) {
                        ItemTableService.save(scope.item);

                        // replace current with edited one
                        scope.item.extend(result);
                        Alert.success('Weekscheme saved successfully');
                    }, function (error) {
                        scope.cancel();
                    });
                } // if
                else {

                    // we have to look if a copy is made -> then include daySchemes also
                    if (typeof scope.item.vmCopyFromId !== 'undefined') {
                        // we have to load daySchemes
                        DayschemeService.dayschemesOfWeekscheme(scope.item.vmCopyFromId).then(function (result) {
                            // add dayschemes to object
                            var dayschemes = [];
                            // iterator over days and times
                            for (var i = 0; i < result.length; i++) {
                                var day = result[i];
                                // reset
                                day.id = 0;
                                day.fK_WeekScheme = 0;
                                var times = [];
                                //iterator over times
                                for (var j = 0; j < day.times.length; j++) {
                                    var time = day.times[j];
                                    // reset
                                    time.id = 0;
                                    time.fK_DayScheme = 0;
                                    delete time.timestamp;
                                    // add to array
                                    times.push(time);
                                } //for
                                // set times array
                                day.times = times;
                                // add to array
                                dayschemes.push(day);
                            } // for
                            // set dayschemes array
                            item.daySchemes = dayschemes;

                            // save 
                            save(item);

                        });
                    } // if
                    else {
                        // normal save
                        save(item);
                    } // else
                } //else              

            };

            // backend save
            function save(item) {
                // set sort order -> latest + 1
                var sortOrder = 1;

                // find highest sort order
                var arr = ItemTableService.list();
                for (var i = 0; i < ItemTableService.list().length; i++) {
                    // only active and id > 0 
                    if (typeof arr[i].id === 'undefined' || arr[i].id === 0 || arr[i].deleted === true) { continue; }
                    // is sortOrder lower -> replace
                    if (sortOrder < arr[i].sortOrder) {
                        sortOrder = arr[i].sortOrder;
                    } //if
                } // for
                // set new sort order
                item.sortOrder = sortOrder + 1;

                WeekschemeService.save(item).then(function (result) {
                    ItemTableService.save(scope.item);

                    // remove current one to put new one
                    ItemTableService.remove(scope.item.vmIndex);
                    ItemTableService.put(result);

                    Alert.success('Weekscheme saved successfully');
                }, function (error) {
                    // remove
                    ItemTableService.remove(scope.item.vmIndex);
                });
            } // save

            // change/transform item from alternately to individual and vice versa
            scope.changeWeekschemeType = function () {
                WeekschemeService.type(scope.item.id).then(function (result) {
                    Alert.success(result);
                    // set new type
                    scope.item.isIndividual = !scope.item.isIndividual;

                    // remove from list -> type changed
                    ItemTableService.remove(scope.item.vmIndex);
                });
            };

            // duplicate a weekscheme
            scope.duplicateWeekscheme = function () {
                // add id of current item -> to know the original id for dayschemes - copy
                var itemToCopy={};
                angular.copy(scope.item,itemToCopy);
                
                itemToCopy.vmCopyFromId = scope.item.id;
                itemToCopy.activationDate=null;
                itemToCopy.startDate=null;
                itemToCopy.endDate=null;
                
                // copy
                ItemTableService.copy(itemToCopy);
            };

            // show days 
            scope.show = function () {

                // open modal
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    animation: true,
                    windowClass: 'modal-100-height modal-60-width',
                    templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/days.template.html',
                    controller: 'WeekschemeDaysController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        weekscheme: function () {
                            var item = new Weekscheme();
                            item.extend(scope.item);
                            return item;
                        },

                        dayschemes: ['DayschemeService', function (DayschemeService) {
                            return DayschemeService.dayschemesOfWeekscheme(scope.item.id);
                        }],

                        labels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
                            return AgendaLabelService.query(SharedAgendaService.data.currentAgenda.id, false);
                        }],

                        interval: ['AgendaService', 'SharedAgendaService', function (AgendaService, SharedAgendaService) {
                            // call api to get updated interval
                            return SharedAgendaService.data.currentAgenda.interval;
                        }]
                    }
                });

                // get result from modal window
                modalInstance.result.then(function (result) {
                    App.unblockUI();
                });


            };


        }
    }

})();